import { render, staticRenderFns } from "./PriceDemo.vue?vue&type=template&id=7a258c11&scoped=true"
import script from "./PriceDemo.vue?vue&type=script&lang=js"
export * from "./PriceDemo.vue?vue&type=script&lang=js"
import style0 from "./PriceDemo.vue?vue&type=style&index=0&id=7a258c11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a258c11",
  null
  
)

export default component.exports